<template>
    <bottom-sheet v-model="shows" v-bind="{ title }">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>

        <form-wrap :value="form" @input="emit" />

        <template #foot>
            <v-btn v-bind="{ loading }" color="error" outlined @click="init"> <span>초기화</span> </v-btn>
            <v-btn v-bind="{ loading }" color="primary" @click="save"> <span>저장하기</span> </v-btn>
        </template>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { EMPLOYMENT_FIELD_TYPES, initEmploymentForm } from "@/assets/variables";
import { mapMutations, mapState } from "vuex";

import BottomSheet from "@/components/console/dumb/bottom-sheet.vue";
import FormWrap from "./form/form-wrap.vue";

export default {
    components: {
        BottomSheet,
        FormWrap,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentForm>} */
        value: { type: Object, default: initEmploymentForm },
    },
    data: () => ({
        shows: false,
    }),
    computed: {
        ...mapState("employment/form", ["form", "loading"]),
        isCreate() {
            return !this.value?._id;
        },
        title() {
            let title = "계약서 양식";
            title += this.isCreate ? " 생성" : " 수정";
            return title;
        },
    },
    methods: {
        ...mapMutations("employment/form", ["setForm", "setLoading"]),
        async init() {
            if (this.loading) return;
            else this.setLoading(true);
            try {
                if (this.isCreate) this.setForm(initEmploymentForm());
                else {
                    let { form } = await api.console.employment.forms.get({ _id: this.value._id });
                    this.setForm(initEmploymentForm(form));
                    this.$store.commit("employment/form/page/increaseKey");
                }
            } finally {
                this.setLoading(false);
            }
        },
        async save() {
            if (!this.validates()) return;
            if (this.loading) return;
            else this.setLoading(true);

            try {
                let { _file, file, _pages, pages, fields, ...form } = this.form;

                ////////////////////////////////////////////////////////////////
                // 데이터 저장
                ////////////////////////////////////////////////////////////////
                let { post, put } = api.console.employment.forms;
                form = (await (!form._id ? post : put)(form))?.form;

                ////////////////////////////////////////////////////////////////
                // 리소스 저장
                ////////////////////////////////////////////////////////////////
                if (file instanceof File) file = (await api.console.employment.files.post({ _form: form._id, index: "file" }, file))?.file;
                if (!!_file && _file != file?._id) await api.console.employment.files.delete({ _form: form._id, _id: _file });
                _file = file?._id || null;

                pages = await Promise.all(
                    pages.map(async (page, index) => {
                        if (page instanceof File) {
                            page = (await api.console.employment.files.post({ _form: form._id, index: `page-${index}` }, page))?.file;
                        }
                        return page;
                    })
                );
                _pages = pages.map(({ _id }) => _id);

                fields = await Promise.all(
                    fields.map(async ({ img, ...field }, index) => {
                        if (img instanceof File) {
                            img = (await api.console.employment.files.post({ _form: form._id, index: `field-${index}` }, img))?.file;
                        }
                        field._img = img?._id || null;
                        return field;
                    })
                );

                ////////////////////////////////////////////////////////////////
                // 업데이트
                ////////////////////////////////////////////////////////////////
                form = (await put({ _id: form?._id, _file, _pages, fields }))?.form;

                alert(this.isCreate ? "생성되었습니다" : "수정되었습니다");
                this.$emit("input", form);
            } finally {
                this.setLoading(false);
                this.shows = false;
            }
        },
        validates() {
            try {
                let hasAnEmptyTermFileField = this.form.fields.some((item) => item.type == EMPLOYMENT_FIELD_TYPES.FILE.value && !item.term);
                if (hasAnEmptyTermFileField) throw new Error("첨부파일 명칭을 입력해주세요");

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },
        emit(form) {
            this.setForm(initEmploymentForm(form));
        },
    },
    watch: {
        value() {
            if (this.shows) this.init();
            else this.$store.dispatch("employment/form/reset");
        },
        shows() {
            if (this.shows) this.init();
            else this.$store.dispatch("employment/form/reset");
        },
    },
};
</script>

<style lang="scss" scoped></style>
